import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { Form, Input, message } from "antd";
import commonRules from "components/Pages/User/common/rules";
import { FaSceneDictEnum } from "store/user";
import SafeVerify from "components/App/SafeVerify";
import { axiosThrottle, doRsaEncrypt, regexp } from "utils/method";
import XtSvg from "components/Xt/Svg";
import { waitRes } from "utils/axios";
import { LoginPasswordDataProps, put_publicKey } from "api/uaapi/account";
import FormItem from "components/App/FormItem";
import FormItemPassword from "components/App/FormItem/Password";
import useNextTick from "hooks/useNextTick";
import { get_getFaCheckItem, post_publicKey, post_updatePasswd } from "@/api/uaapi/user";
import { FaCheckProps } from "@/components/App/SafeVerify";
interface LoginPasswordProps extends BaseCompProps {
  attr?: any;
}
const { useIntl, useTranslation, FormattedMessage } = Hooks as any;
const { useForm } = Form;
const initForm: LoginPasswordDataProps = {
  newPassword: "",
  oldPassword: "",
  newPassword2: "",
  faId: "",
};
let faResultId = "";
const LoginPassword: React.FC<LoginPasswordProps> = ({ className }) => {
  const t = useTranslation();
  const intl = useIntl();
  const router = useRouter();
  const nextTick = useNextTick();
  const { isDark } = store.app;
  const [formIns] = useForm();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const faBizType = 11;
  const [OldPasswordState, setOldPasswordState] = useState({
    isOK: false,
    errMsg: "",
  });
  const [passwordState, setPasswordState] = useState({
    isOK: false,
    errMsg: "",
  });
  const [passwordState2, setPasswordState2] = useState({
    isOK: false,
    errMsg: "",
  });
  const [faCheckData, setFaCheckData] = useState<FaCheckProps>({
    faCheckId: "",
    email: "",
    countryCode: "",
    mobile: "",
    faItems: [],
  });
  useEffect(() => {
    getFaCheckItem();
  }, []);

  const getFaCheckItem = async () => {
    const { data, err } = await waitRes(get_getFaCheckItem, {
      noHandle401: true,
      errorPop: true,
      params: { faBizType },
    });
    if (err) return;

    faResultId = data.faCheckId;
    setFaCheckData(data);
  };

  /**method */
  // const onValuesChange = (changedValues: Partial<LoginPasswordDataProps>) => {
  //   setFormData({ ...formData, ...changedValues });
  // };

  const getPublicKey = async () => {
    const { data, err } = await waitRes(post_publicKey, {
      errorPop: true,
    });
    if (err) return;
    return data;
  };

  const submitForm = axiosThrottle(async (unlock, res) => {
    try {
      await formIns.validateFields();

      const { publicKey, passwdId } = await getPublicKey();
      console.log(publicKey, oldPassword, newPassword, "publicKey");
      const oldPasswordNew = doRsaEncrypt(publicKey, oldPassword);
      const newPasswordNew = doRsaEncrypt(publicKey, newPassword);

      const { err } = await waitRes(post_updatePasswd, {
        errorPop: true,
        data: {
          oldPassword: oldPasswordNew,
          newPassword: newPasswordNew,
          passwdId,
          faResultId: res.faResultId,
        },
      });
      unlock();
      if (err) return;
      message.success(t("2fa.updatePasswdSuccess"), () => {
        store.user.resetStatusToNotLogin();
        router.push(`/accounts/login`);
      });
    } catch (error) {}
  });

  const verify_oldPassword = (bool) => {
    const newVal = oldPassword;
    const errMsg = intl.formatMessage({ id: "register.plsInputPwd" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("loginPassword", newVal)) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "app.pwdErrorTip" }, { 0: 8 }),
      };
    }
    setOldPasswordState(status);
    return status;
  };

  const verify_password = (bool) => {
    const newVal = newPassword;
    const errMsg = intl.formatMessage({ id: "register.plsInputPwd" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("loginPassword", newVal)) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "app.pwdErrorTip" }, { 0: 8 }),
      };
    } else if (newVal !== newPassword2 && newPassword2) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "2fa.pwdNoMatch" }, { 0: 8 }),
      };
    }
    setPasswordState(status);
    return status;
  };

  const verify_password2 = (bool) => {
    const newVal = newPassword2;
    const errMsg = intl.formatMessage({ id: "register.plsInputPwd" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("loginPassword", newVal)) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "app.pwdErrorTip" }, { 0: 8 }),
      };
    } else if (newVal !== newPassword && newPassword) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "2fa.pwdNoMatch" }, { 0: 8 }),
      };
    }
    setPasswordState2(status);
    return status;
  };

  return (
    <div className={cx(styles.mobile, className, isDark ? styles["loginPassword_dark"] : styles["mobile_light"])}>
      {/* 顶栏由 pages/accounts/user 的 backHeader 统一提供 */}
      <div className={styles["content"]}>
        <div className={styles["right_fa"]}>
          {/* 更改登录密码 */}
          <div className={styles["right_1"]}>
            <div className={styles["title"]}>{t("sign.change")}</div>
            <div className={styles["tan"]}>
              <XtSvg src={require("@/assets/icon-svg/app/tan.svg")} />
              <div className={styles["text_tan"]}>{t("account.safeFund")}</div>
            </div>
            <div className={styles["tip"]}>
              <Form name="mobileForm" form={formIns} layout="vertical">
                <div className={styles["email_text"]}>{t("sign.oldCode")}</div>
                <Form.Item className={styles["n-country-box"]}>
                  <FormItem title={<FormattedMessage id="sign.old" />} errMsg={OldPasswordState.errMsg} style={{ width: "100%", marginBottom: 0 }}>
                    <FormItemPassword
                      /* eslint-disable */
                      // @ts-ignore
                      autoComplete={"new-password"}
                      isErr={!!OldPasswordState.errMsg}
                      value={oldPassword}
                      onInput={setOldPassword}
                      onBlur={() => verify_oldPassword(1)}
                    />
                  </FormItem>
                </Form.Item>
                <div className={styles["email_text"]}>{t("sign.newSet")}</div>
                <Form.Item className={styles["n-country-box"]}>
                  <FormItem title={<FormattedMessage id="sign.new" />} errMsg={passwordState.errMsg} style={{ width: "100%", marginBottom: 0 }}>
                    <FormItemPassword
                      /* eslint-disable */
                      // @ts-ignore
                      autoComplete={"new-password"}
                      isErr={!!passwordState.errMsg}
                      value={newPassword}
                      onInput={setNewPassword}
                      onBlur={() => verify_password(1)}
                    />
                  </FormItem>
                </Form.Item>
                <Form.Item className={styles["n-country-box"]}>
                  <FormItem title={<FormattedMessage id="sign.sureNew" />} errMsg={passwordState2.errMsg} style={{ width: "100%", marginBottom: 0 }}>
                    <FormItemPassword
                      /* eslint-disable */
                      // @ts-ignore
                      autoComplete={"new-password"}
                      isErr={!!passwordState2.errMsg}
                      value={newPassword2}
                      onInput={setNewPassword2}
                      onBlur={() => verify_password2(1)}
                    />
                  </FormItem>
                </Form.Item>
              </Form>
              {/* 安全验证 */}
              {faCheckData.faItems.length > 0 && <div className={styles["email_text"]}>{t("app.2fa")}</div>}
              <SafeVerify faCheckData={faCheckData} showLink={true} faBizType={faBizType} dynamicCodeType={"USER_2008"} handleSuccessFn={submitForm} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default observer(LoginPassword);
